import React from 'react';
import { FaCartPlus } from 'react-icons/fa'

const addToCart = ({id, price, url, image, name, buttonText }) => {
    return (
        <button class="snipcart-add-item button primary mr-1"
            data-item-id={id}
            data-item-price={price}
            data-item-url={url}
            data-item-image={image}
            data-item-name={name}
        >{buttonText} <FaCartPlus /></button>
    );
};

export default addToCart;